module.exports = __webpack_public_path__ + "img/content5-3.bcb8cd64.webp";